import { DateFormat } from '@common/types/general/date-time';

export const MONITORING_DATE_FORMAT = DateFormat.DDMMYYYYPeriod;
